<template>
  <form-element
    v-model="payMethod"
    :required="true"
    :form-element="formElement"
  />
</template>

<script>
import FormElement from "../form/FormElement"
import { getPayMethods } from "../../services/checkout"

export default {
  name: "CartPayMethods",
  components: { FormElement },
  props: {
    value: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      payMethod: null,
      payMethods: [],
      formElement: {
        name: "payMethodID",
        label: this.$t("payMethod"),
        type: "select",
        selectLabel: "description",
        selectValue: "payMethodID",
        options: [],
        value: "",
        disabled: false,
        placeholder: this.$t("selectAPaymethod"),
        required: true,
        size: {
          md: 6,
          lg: 6,
        },
      },
    }
  },
  watch: {
    payMethod(payMethod) {
      this.$emit("input", payMethod)
    },
  },
  async created() {
    this.formElement.value = this.value
    await this.getPayMethods()
    // get formElement options where default value is true

    this.payMethod =
      this.formElement.options.filter((payMethod) => payMethod.default)[0]
        .payMethodID ?? null
  },
  methods: {
    async getPayMethods() {
      const result = await getPayMethods()
      this.formElement.options = result
    },
  },
}
</script>

<style scoped></style>
